<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            Department of Agri Product Sale and Marketing/ ໃບຮຽກເກັບ B2B
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 6 || roleid == 7">
        <b-tab-item label="ລາຍການສັນຍາ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ລາຍການສັນຍາ">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="2%">#</th>
                      <th class="has-text-left " width="10%">
                        ຊື່ B2B
                      </th>
                      <th class="has-text-left " width="10%">
                        ທີ່ຢູ່
                      </th>
                      <th class="has-text-centered " width="10%">
                        ເລກທີສັນຍາ
                      </th>

                      <th class="has-text-centered " width="10%">
                        ວັນທີສັນຍາ
                      </th>
                      <th class="has-text-centered " width="10%">
                        ຈຳນວນເງິນ
                      </th>
                      
                      <th class="has-text-centered " width="10%">
                        ວັນທີ<br>
                        ໃບເກັບເງິນ
                      </th>
                      <th class="has-text-centered " width="10%">
                        ວັນທີ<br>
                        ໄດ້ຮັບເງິນ
                      </th>
                      
                     
                      <th class="has-text-centered " width="10%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in activemarkets" :key="data.ID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.B2BUSERNAME }}
                      </td>
                      <td>
                        {{ data.VILLAGE }} <br>
                        {{ data.DISTRICT }} <br>
                        {{ data.PROVINCENAME }}
                      </td>
                      <td class="has-text-centered"> 
                        {{ data.CONTRACTNO }}/ {{ data.SUBCONTRACTNO }} 
                      </td>
                      <td class="has-text-centered"> 
                        {{ dateFormatter(data.CONTRACTDATE) }}
                      </td>
                      
                      <td class="has-text-centered"> 
                        <b-field v-if="data.TOTAL">
                          {{ data.TOTAL | formatNumberLocal}}
                        </b-field>
                        <b-input v-else v-model.trim="data.total" type="number"> </b-input>
                      </td>
                      <td class="has-text-centered">
                        {{data.REQUESTDATE ? dateFormatter(data.REQUESTDATE) : '' }}
                      </td>
                      <td class="has-text-centered"> 
                        {{data.RECEIVEDDATE ? dateFormatter(data.RECEIVEDDATE) : '' }}
                      </td>
                  

                      <td class="has-text-centered">
                        <b-field group>
                          <b-field v-if="!data.FORMSTATUS">
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="
                                createB2BReceipt(data)
                              "
                              >ອອກໃບຮຽກເກັບ
                            </b-button>
                          </b-field>
                          <b-field v-if="data.FORMSTATUS && data.FORMSTATUS==0">
                            <b-button
                              class="btn-group-margin"
                              type="is-success"
                              size="is-small"
                              @click="
                                changeB2BReceiptStatus(data.FORMID,1)
                              "
                              >ຢືນຢັນ
                            </b-button>
                          </b-field>
                          <b-field v-if="data.FORMSTATUS && data.FORMSTATUS==0">
                            <b-button
                              class="btn-group-margin"
                              type="is-danger"
                              size="is-small"
                              @click="
                                changeB2BReceiptStatus(data.FORMID,-1)
                              "
                              >ຍົກເລີກ
                            </b-button>
                          </b-field>
                          <b-field v-if="data.FORMSTATUS && data.FORMSTATUS==1">
                            <b-button
                              class="btn-group-margin"
                              type="is-success"
                              size="is-small"
                              @click="
                                changeB2BReceiptStatus(data.FORMID,2)
                              "
                              >ຢືນຢັນການຮັບເງິນ
                            </b-button>
                          </b-field>
                          <b-field v-if="data.FORMSTATUS && data.FORMSTATUS==2">
                            <b-button
                              class="btn-group-margin"
                              type="is-info"
                              size="is-small"
                              >ໄດ້ຮັບເງິນແລ້ວ
                            </b-button>
                          </b-field>
                          <!-- <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-info"
                              size="is-small"
                              @click="
                                gotoquotaToProduction(data.ID, data.MARTKETNAME)
                              "
                              >ຢືນຢັນການຮັບເງິນ
                            </b-button>
                          </b-field> -->
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>

        

        
      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
// import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  // components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      userName: null,
      roleid: null,
      activemarkets: [],
      inactivemarkets: [],
      marketid: null,
      marketname: null,
      userBranchid: null,

      activeTab: 0,
      saveAction: true,
      updateAction: false,
      adddataform: true,
      updatedataform: false,

      activeSubTab: 0,
      productType: [],
      products: [],
      productamount: [],
      selecteddate: null,
      prequota: [],

      activeFormTab: 0,

      activeWaitTab: 0,

      quotaltoproduction: [],
      activeQuotaSubTab: 0,
      quotadate: null,
      quotadatetypes: null,
      quotadateproducts: null,
      selectedquotaddate: null,

      dateproductions: [],

      isActiveQuotaForm: true,
      preQuotaList: [],
      postQuotaList: [],
      isPreQuotaDetail: false,
      preQuotaProductList: [],
      postQuotaProductList: [],
      selectedRedate: null,

      farmerList: [],
      marketSelectedDate: null,

      selectedProductionid: null,
      farmerProductionList: [],
      isFarmerProduction: false,
      farmerProductionFarmername: null,
      farmerProductionRequestID: null,
      farmerProductionRedate: null,
      farmerProductionGetplandate: null,
      farmerProductionID: null,
      farmerProductionFarmID: null,
      farmerProductionFarmerID: null,
      farmerProductionTotalAmount: null,
      farmerProductionProductid: null,
      farmerProductionProductname: null,
      farmerProductionUnit: null,
      farmerProductionAmount: null,
      farmerProductionRecommentdate: null,
      farmerProductionProdate: null,
      farmerProductionProamount: null,
      farmerProductionHarvestdate: null,
      farmerProductionHarvestamount: null,
      farmerProductionProstatus: null,
      selectedAction: null,

      actionAmount: 0,
      actionDate: null,
      reportDate: null,
      selectedProductionAction: null,
      productionActionList: [
        { ACTIONID: "0", ACTIONNAME: "ເລືອກ" },
        { ACTIONID: "1", ACTIONNAME: "ເລີ່ມຜະລິດ" },
        { ACTIONID: "2", ACTIONNAME: "ເກັບກ່ຽວ" },
      ],
      productionReportDetail: null,
      productionReportList: [],

      waitstatus: null,
      search: null,

    };
  },
  methods: {
    getB2BContractList() {
      console.log("market");
      RestAPI.getB2BContractList()
        .then((res) => {
          console.log("list:" + JSON.stringify(res.data));
          this.activemarkets = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    createB2BReceipt(data){
       if(data.total) {
        this.$swal({
          title: "ຕ້ອງການດຳເນີນການແທ້ບໍ່ ແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.value) {
            var params = {
              contractid: data.ID,
              b2busername:data.B2BUSERNAME,
              b2bcontractno: data.CONTRACTNO,
              b2bsubcontractno: data.SUBCONTRACTNO,
              total : data.total, 
              branchid : this.userBranchid,
              username: this.username,

            };
            // console.log("params: ", JSON.stringify(params));
            RestAPI.createB2BReceipt(params)
              .then(() => {
                this.$swal("ສຳເລັດ!", "", "success");
                this.getB2BContractList();
              })
              .catch((error) => {
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                }
            });
          }
        });
      }else{
        this.$swal("ກະລູນາປ້ອນຈຳນວນເງິນ", "", "error");
      }
    },

    changeB2BReceiptStatus(id, status){

        var params = {
          id: id,
          status: status,
          username: this.username,

        };
        RestAPI.changeB2BReceiptStatus(params)
          .then(() => {
            this.$swal("ສຳເລັດ!", "", "success");
            this.getB2BContractList();
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
        });
    
    },

    

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },

    print() {
      window.print();
    },
  },
  mounted() {
    // console.log("this.user.BRANCHPROVNICEID: " + JSON.stringify(this.user));
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.userProvinceID = this.user.BRANCHPROVNICEID
      ? this.user.BRANCHPROVNICEID
      : "all";
    this.userBranchid = this.user.DASMBRANCHID;
    this.getB2BContractList();
  },
  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
